/* LOSMIOS collection — filter toggle + AJAX load more. No deps. */
(function () {
  function init(root) {
    if (!root || root.dataset.lmInit) return;
    root.dataset.lmInit = '1';

    var toggle = root.querySelector('[data-lm-filtoggle]');
    var panel = root.querySelector('[data-lm-filters]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var hidden = panel.hasAttribute('hidden');
        if (hidden) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', String(hidden));
      });
    }

    // Load more (progressive)
    var btn = root.querySelector('[data-lm-loadmore-btn]');
    var gridEl = root.querySelector('[data-lm-grid]');
    if (btn && gridEl) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.next;
        if (!url) return;
        btn.disabled = true;
        btn.textContent = btn.dataset.loading || 'Cargando…';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-lm-grid]');
            var newBtn = doc.querySelector('[data-lm-loadmore-btn]');
            if (newGrid) { Array.prototype.forEach.call(newGrid.children, function (c) { gridEl.appendChild(c); }); }
            if (newBtn && newBtn.dataset.next) {
              btn.dataset.next = newBtn.dataset.next;
              btn.disabled = false;
              btn.textContent = btn.dataset.label || 'Ver más';
            } else {
              btn.parentNode.removeChild(btn);
            }
          })
          .catch(function () { btn.disabled = false; btn.textContent = btn.dataset.label || 'Ver más'; });
      });
    }
  }
  function boot() { document.querySelectorAll('[data-lm-collection]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lm-collection]').forEach(init);
  });
})();
